import { useRef, useState } from "react";
import { Menu } from "primereact/menu";
import Button from "../../componentes/button/button";

export function TabelaVeiculo({
    data,
    loading,
    visualizar,
    editar,
    excluir,
    setPage
}) {

    const initialSort = {
        key: "placa",
        direction: "asc",
    }

    const [sortConfig, setSortConfig] = useState(initialSort);


    function headerTable(title, direction, align = "left") {
        return (
            <th
                className={
                    "px-6 py-3 text-" +
                    align +
                    " text-xs font-medium text-table-header-fg uppercase tracking-wider cursor-pointer"
                }
                onClick={() => direction && handleSort(direction)}
            >
                {title}
                {direction && sortConfig.key === direction &&
                    (sortConfig.direction === "asc" ? " ↑" : " ↓")}
            </th>
        );
    }

    const handleSort = (key) => {
        const nextDirection =
            sortConfig.key === key && sortConfig.direction === "asc"
                ? "desc"
                : "asc";

        setSortConfig({
            key,
            direction: nextDirection,
        });

        setPage((prev) => ({
            ...prev,
            page: 0,
            sortKey: key,
            sortDirection: nextDirection,
        }));
    };

    return (
        <div className="table-responsive overflow-y-auto fade-in pb-6">
            <table className="min-w-full divide-y divide-table-border">
                <thead className="bg-table-header">
                    <tr>
                        {headerTable("Filial", "filial.nome")}
                        {headerTable("Placa/Código", "placa")}
                        {headerTable("Código York", "codigoYork")}
                        {headerTable("Código Solar", "codigoSolar")}
                        {headerTable("Status", "ativo")}
                        <th className="px-6 py-3 text-center text-xs font-medium text-table-header-fg uppercase tracking-wider">
                            Ações
                        </th>
                    </tr>
                </thead>

                <tbody className={`fade-in bg-card divide-y divide-table-border ${loading && 'opacity-50 pointer-events-none'}`}>
                    {data?.totalElements === 0 ? (
                        <tr>
                            <td
                                colSpan={8}
                                className="text-center py-4 text-muted-foreground text-sm"
                            >
                                <i className="fa fa-exclamation-circle text-amber-500" />  Nenhum registro encontrado para os filtros selecionados
                            </td>
                        </tr>
                    ) : (
                        data.content.map((row) => (
                            <tr
                                key={row.id}
                                className="highlight-row hover:bg-table-row-hover transition-colors"
                            >
                                <td className="px-6 py-2 whitespace-nowrap text-sm text-foreground">
                                    {row.filialNome}
                                </td>


                                <td className="px-6 py-1 whitespace-nowrap">
                                    <div className="text-sm font-semibold text-foreground">
                                        {row.placa}
                                    </div>

                                </td>

                                <td className="px-6 py-2 whitespace-nowrap text-sm text-foreground">
                                    {row.codigoYork}
                                </td>

                                <td className="px-6 py-2 whitespace-nowrap text-sm text-foreground">
                                    {row.codigoSolar}
                                </td>

                                <td className="px-6 py-2 whitespace-nowrap text-sm">
                                    {row.ativo ?
                                        <span className="py-1 px-4 rounded-full bg-accent text-accent-foreground text-sm">
                                            Ativo
                                        </span>
                                        :
                                        <span className="py-1 px-4 rounded-full bg-muted text-muted-foreground text-sm">
                                            Inativo
                                        </span>
                                    }
                                </td>

                                <td>
                                    <div className="flex text-xl justify-center gap-2 mx-1">
                                        <ActionDropdown
                                            row={row}
                                            visualizar={visualizar}
                                            editar={editar}
                                            excluir={excluir}
                                            ativo={row.ativo}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}


const ActionDropdown = ({ row, visualizar, editar, excluir, ativo }) => {
    const menu = useRef(null);

    const items = [
        {
            label: 'Visualizar Veículo',
            icon: 'fa fa-eye w-4',
            command: () => visualizar(row)
        },
        {
            label: 'Editar Veículo',
            icon: 'fa fa-edit w-4',
            command: () => editar(row)
        },
        {
            label: ativo ? 'Cancelar Veículo' : 'Reativar Veículo',
            icon: ativo ? 'fa fa-times w-4' : 'fa fa-check w-4',
            command: () => excluir(row)
        }
    ];

    return (
        <div className="flex justify-center">
            <Menu model={items} popup ref={menu} />
            <Button
                variant="gray"
                iconLeft="fa fa-bars"
                onClick={(e) => menu.current.toggle(e)}
            />
        </div>
    );
};
